const DEFAULT_EDGE_BASE_URL = "http://localhost:50268";

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const getEnv = (name) =>
  typeof process !== "undefined" && process.env ? process.env[name] : undefined;

export const getEdgeApiBaseUrl = () => {
  const baseUrl = getEnv("REACT_APP_API_BASE_URL") || DEFAULT_EDGE_BASE_URL;
  return trimTrailingSlash(baseUrl);
};

export const getCentralApiBaseUrl = () => {
  const baseUrl =
    getEnv("REACT_APP_CENTRAL_API_BASE_URL") || getEdgeApiBaseUrl();
  return trimTrailingSlash(baseUrl);
};

export const buildAuthHeaders = (headers, getState) => {
  const token = getState?.()?.auth?.token;
  if (token) {
    headers.set("authorization", `Bearer ${token}`);
  }

  const deviceToken =
    (typeof localStorage !== "undefined" &&
      (localStorage.getItem("edgeDeviceToken") ||
        getEnv("REACT_APP_DEVICE_TOKEN"))) ||
    "";

  if (deviceToken) {
    headers.set("X-DEVICE-TOKEN", deviceToken);
  }

  return headers;
};

